module.exports = __webpack_public_path__ + "static/media/nasa1.d9a0d4e9.png";